"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiBiometrics {
    // Returns empty Ok
    static storePublicKey(token, body) {
        let url = "/biometrics/storeKey";
        return Client_1.default.httpPost(url, token, body);
    }
    // Returns empty Ok
    static deletePublicKey(token) {
        let url = "/biometrics/deleteKey";
        return Client_1.default.httpPost(url, token, {});
    }
    static verifyBiometrics(body) {
        let url = "/VerifyBiometrics";
        return Client_1.default.httpGCFPost(url, body);
    }
}
exports.default = ApiBiometrics;
